import { createGlobalStyle } from "styled-components";


export default createGlobalStyle`
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}


html {
  scroll-behavior: smooth;
}
h2 {
  font-size: 30px;
}

h3 {
  font-size: 20px;
}
a {
  text-decoration: none;
  color: ${props => props.theme.linksColor};
}


body {
  background-color: ${props => props.theme.backgroundColor};
  color: ${props => props.theme.textColor};
  font-family: "Roboto", sans-serif;
  height: 100%;
}

`